import { Box, Paper, Stack } from '@mui/material'
import React from 'react'
import PropaneIcon from '@mui/icons-material/Propane';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import { CaptionText, MainButton, SmallText } from '../../helpers';
import { OrderSteps } from '../schedule-order/OrderSteps';
import { customStyles } from '../../../styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getTrackingOrder } from '../../../slices/orderSlice';
export const OrderTab = ({ data }) => {
  const { type, date, end, status, total, folio,  } = data
  const navigate= useNavigate()
  const dispatch = useDispatch()
  const handleTrackOrder = () => {
    dispatch(getTrackingOrder(data))
    navigate('/dashboard/track-order')
  }
  return (
    <Stack spacing={2} mb={2} sx={{ boxShadow: customStyles.shadows.light, padding: 2,borderRadius: 3, backgroundColor: customStyles.colors.backgroundColor }}>
      <Stack direction="row" justifyContent="space-between">
      <Stack direction="row">
        { type === 'PORTATIL' ? <PropaneTankIcon sx={{ marginRight: 3, color: customStyles.colors.secondary }}/> :  <PropaneIcon sx={{ marginRight: 3, color: customStyles.colors.secondary }}/>}       
        <SmallText text={`Gas ${ type === 'PORTATIL' ? 'Cilindro' : 'Estacionario' }`} bold/>
      </Stack>
      <SmallText text={`$ ${total} MXN`} bold/>
      </Stack>
      <CaptionText text={`fecha estimada de entrega ${ date.replaceAll('-','/') } - ${end}`} color={customStyles.colors.textColor}/>
      <OrderSteps status={status}/>
      <MainButton size="100%" variant="outlined" text="RASTREAR PEDIDO" onClick={handleTrackOrder}/>
    </Stack>
  )
}
